export const createBlankCustomQuantitativeIndicator = (t, organizationUUID) => ({
    indicatorType: 'QUANTITATIVE',
    indicatorId: 0,
    organizationUUID: organizationUUID,
    indicatorUUID: null,
    indicatorName: '',
    description: '',
    indicatorScope: 'ORGANIZATION',
    indicatorEnabled: true,
    quantitativeMeasurementUnitDTO: null,
});

export const createBlankCustomQualitativeIndicator = (t, organizationUUID) => ({
    indicatorType: 'QUALITATIVE',
    indicatorId: 0,
    organizationUUID: organizationUUID,
    indicatorUUID: null,
    indicatorName: '',
    description: '',
    indicatorScope: 'ORGANIZATION',
    indicatorEnabled: true,
    qualitativeTypeDTO: null,
});

export const createBlankCustomQuantitativeDimensionalIndicator = (t, organizationUUID) => ({
    indicatorType: 'QUANTITATIVE_DIMENSIONAL',
    indicatorId: 0,
    organizationUUID: organizationUUID,
    indicatorUUID: null,
    indicatorName: '',
    description: '',
    indicatorScope: 'ORGANIZATION',
    indicatorEnabled: true,
    quantitativeMeasurementUnitDTO: null,
    dimensionalType: null,
});